/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Weighings_Grower_LabelInputs */

const vi_my_weighings_grower_label = /** @type {(inputs: My_Weighings_Grower_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ trồng`)
};

/**

* @param {My_Weighings_Grower_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_weighings_grower_label = /** @type {((inputs?: My_Weighings_Grower_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Weighings_Grower_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_weighings_grower_label(inputs)
});